import React from "react";
import { Icon } from "@abb/abb-common-ux-react";
import { Translation } from "react-i18next";

interface ILandingprops {
    showKeyedInProperty: () => void;
    showKeyedInPropertyDetails: () => void;
}

export default class KeyedInPropertyDetails extends React.Component<ILandingprops, any>{

    constructor(props: any) {
        super(props);

    }

    render() {

        return (
            <Translation>
                {(t) => (
                    <React.Fragment>
                        <div className="col-12">
                            <button title="btn" className="icon-button circle active" onClick={this.props.showKeyedInPropertyDetails}>
                                <Icon name="abb/left" sizeClass="small" />
                            </button>
                            <div className="divider"></div>
                            <div className="table-data-container">
                                <table className="table  table-striped propertyTable editProperty" >
                                    <thead>
                                        <tr>
                                            <th className="instrument">
                                                <div className="measureItems">
                                                    <div className="details">
                                                        <p className="title">Front</p>
                                                        <p>Pending</p>
                                                        <p>0 (5)</p>
                                                    </div>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="instrument">
                                                <div>
                                                    Wax strip
                                                    <span>unit <span className="val">(120)</span></span>
                                                </div>
                                            </td>
                                            <td className="property">-</td>
                                            <td className="property"><input type="text" placeholder="Value" className="tableEdit" /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </Translation>
        )
    }
}